"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonRequestHeaders_1 = require("./factory/jsonRequestHeaders");
var timeZoneContext_1 = require("./factory/timeZoneContext");
var timeZoneDefinitionType_1 = require("./factory/timeZoneDefinitionType");
var extendedPropertyUri_1 = require("./factory/extendedPropertyUri");
function getJsonRequestHeader(timeZone) {
    return jsonRequestHeaders_1.default({
        RequestServerVersion: "Exchange2015",
        TimeZoneContext: timeZoneContext_1.default({
            TimeZoneDefinition: timeZoneDefinitionType_1.default({
                Id: timeZone != null ? timeZone : "Pacific Standard Time",
            })
        })
    });
}
exports.getJsonRequestHeader = getJsonRequestHeader;
function getExtendedPropertyUri(propertySetID, propertyName, propertyType) {
    return extendedPropertyUri_1.default({
        PropertySetId: propertySetID,
        PropertyName: propertyName,
        PropertyType: propertyType
    });
}
exports.getExtendedPropertyUri = getExtendedPropertyUri;
